// deno-lint-ignore-file no-explicit-any
import { init } from "@instantdb/react";
import { useEffect, useState } from "preact/hooks";
import { instantdbAppId } from "../../constants.ts";
import schema from "../../instant.schema.ts";

const originalDb = init({
  appId: instantdbAppId,
  schema,
  devtool: false,
}) as any;

export const useQuery = (query: any) => {
  if (typeof globalThis !== "undefined" && (globalThis as any).__MOCK_QUERY__) {
    return (globalThis as any).__MOCK_QUERY__(query);
  }
  return originalDb.useQuery(query);
};
export const useInfiniteQuery = (query: any) => {
  if (
    typeof globalThis !== "undefined" &&
    (globalThis as any).__MOCK_INFINITE_QUERY__
  ) {
    return (globalThis as any).__MOCK_INFINITE_QUERY__(query);
  }
  return originalDb.useInfiniteQuery(query);
};
export const tx = originalDb.tx;
export const transact = (...args: any[]) => {
  if (
    typeof globalThis !== "undefined" && (globalThis as any).__MOCK_TRANSACT__
  ) {
    return (globalThis as any).__MOCK_TRANSACT__(...args);
  }
  return originalDb.transact(...args);
};

export const useAuth = () => {
  if (typeof globalThis !== "undefined" && (globalThis as any).__MOCK_AUTH__) {
    const [state, setState] = useState((globalThis as any).__MOCK_AUTH__());
    useEffect(() => {
      const handler = () => {
        setState((globalThis as any).__MOCK_AUTH__());
      };
      globalThis.addEventListener("__MOCK_AUTH_CHANGE__", handler);
      return () =>
        globalThis.removeEventListener("__MOCK_AUTH_CHANGE__", handler);
    }, []);
    return state;
  }
  return originalDb.useAuth();
};

export const getAuth = () => originalDb.getAuth();

export const auth = new Proxy(originalDb.auth, {
  get(target, prop) {
    if (
      typeof globalThis !== "undefined" &&
      (globalThis as any).__MOCK_AUTH_METHODS__?.[prop]
    ) {
      return (globalThis as any).__MOCK_AUTH_METHODS__[prop];
    }
    return (target as any)[prop];
  },
}) as any;

export const storage = originalDb.storage;
